import { useQuery } from 'src/shared/lib/useQuery';
import { useOrg } from 'src/shared/contexts/OrgContext';
import { genQueryKey } from 'src/shared/lib/query.utils';
import { QueryResult } from 'src/shared/types/util.types';

// Returns `null` when no integration exists instead of throwing, so the UI can
// gracefully show the "Integration not found" state without a noisy 404 error.
export function useIntegration(email?: string, type?: string): QueryResult<{ id: string } | null> {
  const { orgFetch, currentOrg, switchOrg } = useOrg();

  const queryKey = ['integration-plugin', genQueryKey(currentOrg.id, email!)];

  return useQuery({
    queryKey: queryKey,
    queryFn: getData,
    enabled: !!email,
    staleTime: 1000 * 60 * 15,
    retry: 2,
  });

  async function getData() {
    let url = `/api/v2/plugin/integration?email=${email}`;
    if (type) {
      url += `&type=${type}`;
    }
    const res = await orgFetch<{ id: string }>(url, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (res.headers.get('X-Org-Id')) {
      switchOrg(res.headers.get('X-Org-Id')!, true);
      await new Promise((resolve) => setTimeout(resolve, 5000));
      return null;
    }

    if (res.status === 404) {
      return null;
    }

    if (!res.ok) {
      throw new Error('Failed to fetch integration for plugin');
    }

    return await res.json();
  }
}
